import React, { useEffect, useState } from "react";
import { useAuth } from "../../../firebase/AuthProvider";
import { getTaskActionTemplate } from "../../../services/taskServices/TaskActionService";
import ActionSubType from "../../../interfaces/task/taskActions/ActionSubType";
import { Link, useNavigate } from "react-router-dom";
import EditTaskActivityType from "./EditTaskActivityType";
import { Button } from "react-bootstrap";
import editicons from '../../../assets/images/editicons.svg';
import backarrowbtn from '../../../assets/images/backarrowbtn.svg';

const CreateNewTaskActivityPage: React.FC = () => {
    const { currentUser, currentRoles } = useAuth();
    const navigate = useNavigate();

    const [activityTemplates, setActivityTemplates] = useState<ActionSubType[]>();
    const [selectedTemplate, setSelectedTemplate] = useState<ActionSubType>();
    const [reload, setReload] = useState<boolean>(false);

    const labelsToFilterOut = [
        "COMMENT",
        "TASK FILE DELETED",
        "FILE UPLOAD",
        "TASK APPROVAL",
        "TASK SUBMISSION",
        "TASK COMPLETED",
        "REJECTED",
    ];

    useEffect(() => {
        const fetchActivityTemplates = async () => {
            if (currentUser !== null) {
                const authToken: string = await currentUser.getIdToken();
                const fetchedTemplates = await getTaskActionTemplate(authToken);
                if (fetchedTemplates) {
                    const filteredOptions = fetchedTemplates.filter(
                        (option) => !labelsToFilterOut.includes(option.actionSubTypeName)
                    );
                    setActivityTemplates(filteredOptions);
                }
            }
        };
        fetchActivityTemplates();
    }, [reload]);

    const selectTemplate = (template: ActionSubType | undefined) => {
        setSelectedTemplate(template);
    };

    const toggleReload = () => {
        setReload(!reload);
    };

    const back = () => {
        setSelectedTemplate(undefined);
    };


    const backBtnUrl = (): string => {
        if (currentRoles?.some((role) => role.name === "OWNER" || role.name === "ADMIN")) {
            return "/dashboard/owner/settings";
        } else {
            return "/settings";
        }
    }
    return (
        <>
            {selectedTemplate ? (
                <div className="new_activity_container">
                    <EditTaskActivityType
                        taskActivity={selectedTemplate}
                        reload={toggleReload}
                        back={back}
                    />
                </div>
            ) : (
                <>
                    <div className="common_card">
                        <div className="top top_bar_flx border_tittle">
                            <div className="top_bar_tittle">
                                <h2>
                                    <Link to={backBtnUrl()}><img style={{ width: '1.5rem' }} src={backarrowbtn} alt="" /></Link>
                                    Task Activity Options
                                </h2>
                            </div>
                            <div className="top_right_flx">
                                <Button style={{ minWidth: 'unset' }} variant="primary" className="btn_sm" onClick={() => navigate("/addActivity/new/activity/template")}>New</Button>
                            </div>
                        </div>
                        <div className="task_activity_options_grid">
                            {activityTemplates &&
                                activityTemplates.map((template, index) => (
                                    <div className="task_activity_options_card" key={index}>
                                        <div className="task_activity_options_card_txt">
                                            <h3>{template.actionSubTypeName}</h3>
                                        </div>
                                        <button className="shrink-0" onClick={() => selectTemplate(template)}>
                                            <img style={{ width: '1.5rem' }} src={editicons} alt="editicons" />
                                        </button>
                                    </div>
                                ))}
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default CreateNewTaskActivityPage;
